import { render, staticRenderFns } from "./waterquery.vue?vue&type=template&id=6aed2efb&scoped=true&"
import script from "./waterquery.vue?vue&type=script&lang=js&"
export * from "./waterquery.vue?vue&type=script&lang=js&"
import style0 from "./waterquery.vue?vue&type=style&index=0&id=6aed2efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed2efb",
  null
  
)

export default component.exports